import React, { useState, useEffect } from "react";
import { Tabs, Tab, Container, Paper, Box, useTheme, CircularProgress } from "@mui/material";
import { styled } from "@mui/system";
import GeneralInfo from "./profile/GeneralInfo";
import OrganizationInfo from "./profile/OrganizationInfo";
import ChangePassword from "./profile/ChangePassword";
import CreateUser from "./profile/CreateUser";
import GetAllUser from "./profile/GetAllUser";
import Greeting from "./Greetings";
import { useAuth } from "../context/AuthProvider";

const StyledTab = styled(Tab)(({ theme, active }) => ({
  textTransform: "none",
  fontWeight: active ? "bold" : "normal",
  color: active ? "#1976d2" : "inherit",
  transition: "color 0.3s ease-in-out",
  "&:hover": {
    color: "white",
    backgroundColor: "#1976d2",
  },
}));

const ProfileForm = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [role, setRole] = useState(null);
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { authToken, orgtype } = useAuth();
  console.log(orgtype);
  const token = localStorage.getItem("access_token");
  const theme = useTheme();

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/profile`,
          {
            method: "GET",
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch profile data");

        const data = await response.json();
        setRole(data.user.user_role);
        setProfileData(data);
      } catch (error) {
        console.error("Error fetching user role:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserRole();
  }, [token]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        padding: 2,
        backgroundColor: theme.palette.mode === "dark" ? "#121212" : "#f5f5f5",
      }}
    >
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Greeting profileData={profileData} />
              <Tabs
                value={activeTab}
                onChange={(e, newValue) => setActiveTab(newValue)}
                sx={{
                  marginBottom: 3,
                  "& .MuiTabs-indicator": {
                    height: "3px",
                    backgroundColor: "#1976d2",
                  },
                }}
              >
                <StyledTab label="General Info" active={activeTab === 0} />
                <StyledTab label="Organization Info" active={activeTab === 1} />
                <StyledTab label="Change Password" active={activeTab === 2} />
                {(role === "admin" && orgtype === "O" || role === "superadmin") && (
                  <StyledTab label="Create User" active={activeTab === 3} />
                )}
                {(role === "admin" && orgtype === "O" || role === "superadmin") && (
                  <StyledTab label="All User" active={activeTab === 4} />
                )}
              </Tabs>
              {activeTab === 0 && <GeneralInfo profileData={profileData} />}
              {activeTab === 1 && <OrganizationInfo profileData={profileData} />}
              {activeTab === 2 && <ChangePassword />}
              {(role === "admin" && orgtype === "O" || role === "superadmin") && activeTab === 3 && <CreateUser />}
              {(role === "admin" && orgtype === "O" || role === "superadmin") && activeTab === 4 && <GetAllUser />}
            </>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default ProfileForm;